import { tierToSeverityLabel } from "@/components/safety-config/risk-groups";

export const RISK_TYPES = [
  "FTC disclosure",
  "Dangerous Activities",
  "Health Misinformation",
  "Misleading Content",
  "Commercial Content",
  "Safety Concerns",
  "Stereotyping / Ridicule",
  "Inappropriate Content",
  "Child appeal",
  "Animal presence",
  "Child consuming",
  "Overconsumption",
  "Alcohol / Tobacco",
  "Unsubstantiated claims",
  "Scarcity",
  "Child spokesperson",
  "Other",
] as const;

export const RISK_TIERS: { value: "1" | "2"; label: string }[] = [
  { value: "1", label: tierToSeverityLabel(1) },
  { value: "2", label: tierToSeverityLabel(2) },
];

export type RiskType = (typeof RISK_TYPES)[number];
export type RiskTier = (typeof RISK_TIERS)[number]["value"];
